import React, {PureComponent} from 'react'

import styled from 'styled-components'
import Select from 'react-select'

import TextInput from '../ui/textInput'
import Button from '../ui/button'
import BaseModal from '../ui/modal'

const stateFromProps = ({organization})=>{
    return {
        organization,
        name: organization ? organization.name : '',
    }
}

export default class OrganizationModal extends PureComponent{
    constructor(props){
        super(props)
        this.state = stateFromProps(props)
    }
    componentWillReceiveProps(props){
        if(props.organization && props.organization !== this.props.organization){
            this.setState(stateFromProps(props))
        }
    }
    onConfirm =()=>{
        let {name} = this.state
        let {organization} = this.props
        if(!this.props.onConfirm) return
        this.props.onConfirm({
            name,
            organization
        })
    }
    onChangeName=(event)=>{
        const {value} = event.target
        this.setState({name: value}) 
    }
    render(){
        const {isOpen, onRequestClose, organization} = this.props
        const {name} = this.state
        return (<BaseModal isOpen={isOpen} onRequestClose={onRequestClose}>
            <div className="modal-header">
                <h3>{organization ? 'Unternehmen bearbeiten' : 'Neues Unternehmen'} </h3>
                <div onClick={onRequestClose} className="close-modal">X</div>
            </div>
            <div className="modal-content">
                <div className="modal-section">
                    <label>Name</label>
                    <TextInput value={name} onChange={this.onChangeName} ref="name"  />
                </div>
                <div className="modal-section">
                    <Button onClick={this.onConfirm} modal>Speichern</Button>
                </div>
            </div>

        </BaseModal>)
    }

}


// WEBPACK FOOTER //
// ./src/components/organizations/organizationModal.js